import {Route,Switch,BrowserRouter } from "react-router-dom";

import ComplaintsTable from "components/Doobi/Complaints";
import DoobiHeader from "components/Headers/DoobiHeader";

const ComplaintsRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Complaints" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={ComplaintsTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default ComplaintsRoute;
